import React, { useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logoFineline from './logo/logo-fineline.png';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  const images = Array.from({ length: 49 }, (_, i) => `/images/i${i + 1}.jpg`);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeService, setActiveService] = useState(null);
  const [expandedSub, setExpandedSub] = useState(null);

  // 🔹 Before/After projects with captions support
  const beforeAfterProjects = [
    {
      title: "Roofing Deck",
        subProjects: [
      {  title: "Project 1",
      before: [
        { src: "/images/Hawde Roofing deck BEFORE.jpg" },
      ],
      secondStep: [
        { src: "/images/Hawde Roofing deck second step.jpg" },
      ],
      after: [
        { src: "/images/Hawde Roofing deck AFTER.jpg" },
      ],
      }
    ]},
    {
      title: "Refinishing and Build New Cedar Wood",
       subProjects: [
      {  title: "Project 1",
      before: [
        { src: "/images/refinishing and build new cedar wood b4 1.jpg", },
        { src: "/images/refinishing and build new cedar wood b4 2.jpg" },
        { src: "/images/refinishing and build new cedar wood b4 3.jpg" },
      ],
      secondStep: [
        { src: "/images/refinishing and build new cedar wood second.jpg", },
        { src: '/images/Removed all pieces damaged.jpg', caption: 'Removed all damaged pieces' },
      { src: '/images/Build a new water-protected base for securing the wood.jpg', caption: 'Build a new water-protected base for securing the wood' },
      { src: '/images/Build a new water-protected base for securing the wood 2.jpg', caption: 'Build a new water-protected base for securing the wood' },
,
      ],
      after: [
        { src: "/images/refinishing and build new cedar wood after 3.jpg"},
        { src: "/images/refinishing and build new cedar wood after 2.jpg" },
      ],
    }]
  },

  {
      title: "Refinishing Siding Cidar Wood",
       subProjects: [
      {
        title: "Project 1",
      before: [
        { src: "/images/refinishing siding ciders wood BEFORE.jpg", },
      ],
      secondStep: [
        { src: "/images/refinishing siding ciders wood SECOND.jpg", },
     
      ],
      after: [
        { src: "/images/refinishing siding ciders wood FINISH.jpg"},
      ],
    },
  {
        title: "Project 2",
      before: [
        { src: "/images/BEFORE.jpg", },
      ],
      secondStep: [
        { src: "/images/SECOND.jpg", },
      ],
      after: [
        { src: "/images/AFTER.jpg"},
      ],
    },
    {
        title: "Project 3",
      before: [
        { src: "/images/BEFORE 1.jpg", },
      ],
      secondStep: [
        { src: "/images/SECOND 1.jpg", },
      ],
      after: [
        { src: "/images/AFTER 1.jpg"},
      ],
    },
    {
        title: "Project 4",
      before: [
        { src: "/images/BEFORE 2.jpg", },
      ],
      secondStep: [
        { src: "/images/SECOND 2.jpg", },
      ],
      after: [
        { src: "/images/AFTER 2.jpg"},
      ],
    },
     {
        title: "Project 5",
      before: [
        { src: "/images/BEFORE 3.jpg", },
      ],
      secondStep: [
      ],
      after: [
        { src: "/images/AFTER 3.jpg"},
      ],
    },
  ]
  }
  
  ];

  const services = [
    'Hardwood & Laminate Flooring',
    'Staircase Remodeling',
    'Custom Wood Carpentry',
    'Vinyl Flooring',
    'Vinyl and rubber baseboards',
    'Kitchen Installation',
    'Door Installation',
    'Deck',
    'Refinishing and Build New Cedar Wood',
    'Tiles',
  ];

  // 🔹 Services images can be string or {src, caption}
  const serviceImages = {
    'Hardwood & Laminate Flooring': [
      '/images/hardwood2.jpg',
      '/images/hardwood1.jpg',
      '/images/hardwood3.jpg',
    ],
    'Staircase Remodeling': [
      '/images/i23.jpg',
      '/images/i24.jpg',
      '/images/i31.jpg',
      '/images/i34.jpg',
      '/images/i36.jpg',
      '/images/i37.jpg',
      '/images/i38.jpg',
      '/images/i39.jpg',
      '/images/i42.jpg',
      '/images/i43.jpg',
      '/images/i44.jpg',
      '/images/s1.jpeg','/images/s2.jpeg','/images/s3.jpeg',
    ],
    'Custom Wood Carpentry': ['/images/i19.jpg', '/images/i20.jpg', '/images/i21.jpg'],
    'Vinyl Flooring': {
      'All': [
        '/images/vinyl1.jpg',
        '/images/vinyl2.jpg',
        '/images/vinyl3.jpg',
        '/images/vinyl4.jpg',
        '/images/vinyl5.jpg',
        '/images/vinyl6.jpg',
        '/images/vinyl new 1.jpg',
        '/images/vinyl new 2.jpg',
        '/images/vinyl new 3.jpg',
        '/images/vinyl new  4.jpg',
        '/images/vv1.jpeg','/images/vv2.jpeg','/images/vv3.jpeg','/images/vv4.jpeg','/images/vv6.jpeg','/images/vv5.jpeg','/images/vv7.jpeg','/images/vv8.jpeg',
      ],
      'Without Transition': [
        '/images/With out transition 1.jpg',
        '/images/With out transition 2.jpg'
      ]
    },
    'Vinyl and rubber baseboards': ['/images/Vinyl and rubber baseboards.jpg'],
    'Kitchen Installation': [ '/images/wp1.jpeg', '/images/wp2.jpeg', '/images/wp3.jpeg'],
    'Door Installation': ['/images/wp4.jpeg' , '/images/wp5.jpeg'],
    'Deck': {
      'Privacy Screen': [
        '/images/Privacy Screen 1.jpg',
        '/images/Privacy Screen 2.jpg',
      ],
      'Roofing Deck': [
        '/images/Hawde Roofing deck AFTER.jpg',
      ],
    },
    'Refinishing and Build New Cedar Wood': [
      { src: '/images/refinishing and build new cedar wood after 2.jpg' },
      { src: '/images/refinishing and build new cedar wood after 3.jpg' },
      
    ],
     'Tiles': [
      '/images/tt1.jpeg', 
      '/images/tt2.jpeg',
      '/images/tt3.jpeg',
      '/images/tt4.jpeg',
      '/images/tt5.jpeg',
      '/images/tt6.jpeg',
      '/images/tt7.jpeg',
      '/images/tt8.jpeg',
     ],
  };

  return (
    <div className="bg-dark text-light">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg px-4 bg-black">
        <a className="navbar-brand d-flex align-items-center">
          <img src={logoFineline} height="40" className="me-2 rounded" alt="Logo" />
        </a>
      </nav>

      {/* Hero */}
      <header
        className="position-relative text-white"
        style={{
          height: '80vh',
          backgroundImage: "url('/images/i46.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}></div>
        <div className="position-relative h-100 d-flex align-items-center justify-content-center">
          <div className="text-center px-4">
            <h1 className="display-4 fw-bold">Crafted to Last</h1>
            <p className="lead fw-bold">Precision flooring & expert carpentry across Canada</p>
            <p>
              We transform your space with an artist's touch, highlighting the beauty in every detail—from the floors up to the finest woodwork
            </p>
            <a href="tel:+16138938931"
              className="d-inline-flex align-items-center gap-3 px-4 py-2 text-dark fw-bold"
              style={{
                backgroundColor: '#FCE6B4',
                borderRadius: '50px',
                textDecoration: 'none',
                fontSize: '1.1rem'
              }}>
              <div className="d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: '#000',
                  color: '#FCE6B4',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  flexShrink: 0
                }}>
                <i className="fas fa-phone-alt fa-rotate-90"></i>
              </div>
              +1 613 893 8931
            </a>
          </div>
        </div>
      </header>

      {/* Services */}
      <section className="py-5 bg-black">
        <div className="container">
          <h2 className="text-center mb-4">Our Services</h2>
          <div className="row g-4">
            {services.map((service, idx) => (
              <div key={idx} className="col-sm-6 col-lg-4">
                <div
                  className={`card h-100 shadow-sm border-0 ${activeService === service ? 'text-dark' : 'bg-dark text-light'}`}
                  style={{
                    cursor: 'pointer',
                    transition: '0.3s',
                    backgroundColor: activeService === service ? '#FCE6B4' : '#212529'
                  }}
                  onClick={() => setActiveService(activeService === service ? null : service)}
                >
                  <div className="card-body">
                    <h5>{service}</h5>
                    <p className="text-secondary">Click to see examples</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Service Gallery */}
          {activeService && (
            <div className="mt-4">
              <h4 className="text-center mb-3">{activeService} Gallery</h4>

              {Array.isArray(serviceImages[activeService]) ? (
                <div className="row g-3">
                  {serviceImages[activeService].map((img, idx) => (
                    <div key={idx} className="col-6 col-md-4 col-lg-3 text-center">
                      <img
                        src={typeof img === "string" ? img : img.src}
                        alt={`${activeService} ${idx + 1}`}
                        onClick={() => setSelectedImage(typeof img === "string" ? img : img.src)}
                        className="img-fluid rounded shadow-sm"
                        style={{ height: '200px', width: '100%', objectFit: 'cover', cursor: 'pointer' }}
                      />
                      {typeof img !== "string" && img.caption && (
                        <small className="d-block mt-2 text-white">{img.caption}</small>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                Object.entries(serviceImages[activeService]).map(([subTitle, imgs], sIdx) => (
                  <div key={sIdx} className="mb-4">
                    <h5 className="text-center mb-3">{subTitle}</h5>
                    <div className="row g-3">
                      {imgs.map((img, idx) => (
                        <div key={idx} className="col-6 col-md-4 col-lg-3 text-center">
                          <img
                            src={typeof img === "string" ? img : img.src}
                            alt={`${subTitle} ${idx + 1}`}
                            onClick={() => setSelectedImage(typeof img === "string" ? img : img.src)}
                            className="img-fluid rounded shadow-sm"
                            style={{ height: '200px', width: '100%', objectFit: 'cover', cursor: 'pointer' }}
                          />
                          {typeof img !== "string" && img.caption && (
                            <small className="d-block mt-2 text-white">{img.caption}</small>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </section>

      {/* Before & After Section */}
      <section className="py-5 bg-dark text-light">
  <div className="container">
    <h2 className="text-center mb-5">Before, Progress & After</h2>

    {beforeAfterProjects.map((project, idx) => (
      <div key={idx} className="mb-5">
        {/* Main Title */}
        <h3 className="mb-4 text-center">{project.title}</h3>

        {project.subProjects.map((sub, subIdx) => {
          const isOpen = expandedSub === `${idx}-${subIdx}`;
          return (
            <div key={subIdx} className="mb-4 border rounded p-3 bg-black">
              {/* Sub-project header */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setExpandedSub(isOpen ? null : `${idx}-${subIdx}`)
                }
              >
                <h5 className="mb-0 text-white">{sub.title}</h5>
                <span className="fs-4">{isOpen ? "▼" : "►"}</span>
              </div>

              {/* Expandable content */}
              {isOpen && (
                <div className="mt-3">
                  <div className="row text-center">
                    {/* Before */}
                    <div className="col-md-4">
                      <h6 className="text-uppercase text-white mb-3">Before</h6>
                      <div className="d-flex flex-wrap justify-content-center gap-3">
                        {sub.before.map((img, i) => (
                          <div key={i}>
                            <img
                              src={img.src}
                              alt={`${sub.title} before ${i + 1}`}
                              className="rounded shadow"
                              style={{ height: "200px", width: "auto", objectFit: "cover" }}
                            />
                            {img.caption && (
                              <small className="d-block mt-2 text-white">{img.caption}</small>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Second Step */}
                    {sub.secondStep && sub.secondStep.length > 0 && (
                      <div className="col-md-4">
                        <h6 className="text-uppercase text-white mb-3">Second Step</h6>
                        <div className="d-flex flex-wrap justify-content-center gap-3">
                          {sub.secondStep.map((img, i) => (
                            <div key={i}>
                              <img
                                src={img.src}
                                alt={`${sub.title} step ${i + 1}`}
                                className="rounded shadow"
                                style={{ height: "200px", width: "auto", objectFit: "cover" }}
                              />
                              {img.caption && (
                                <small className="d-block mt-2 text-white">{img.caption}</small>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* After */}
                    <div className={`col-md-${sub.secondStep?.length > 0 ? "4" : "8"}`}>
                      <h6 className="text-uppercase text-white mb-3">After</h6>
                      <div className="d-flex flex-wrap justify-content-center gap-3">
                        {sub.after.map((img, i) => (
                          <div key={i}>
                            <img
                              src={img.src}
                              alt={`${sub.title} after ${i + 1}`}
                              className="rounded shadow"
                              style={{ height: "200px", width: "auto", objectFit: "cover" }}
                            />
                            {img.caption && (
                              <small className="d-block mt-2 text-white">{img.caption}</small>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    ))}
  </div>
</section>

      {/* Gallery */}
      <section className="py-5 bg-dark">
        <div className="container">
          <h2 className="text-center mb-4">Gallery</h2>
          <div className="row g-3" style={{ backgroundColor: "#FCE6B4" }}>
            {images.map((src, idx) => (
              <div key={idx} className="col-4 col-lg-2">
                <img
                  src={src}
                  alt={`Project ${idx + 1}`}
                  className="img-fluid rounded shadow-sm"
                  style={{ objectFit: 'cover', height: '200px', width: '100%', cursor: 'pointer' }}
                  onClick={() => setSelectedImage(src)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Showcase */}
      <section className="py-5 bg-black text-light">
        <div className="container text-center">
          <h2 className="mb-4">Watch Us in Action</h2>
          <div className="ratio ratio-16x9 shadow rounded overflow-hidden">
            <iframe src="/videos/fineline-vid.mp4" title="Fineline Carpentry Video" allowFullScreen></iframe>
          </div>
          <p className="mt-3 text-secondary fw-bold">See how we bring dream floors to life with precision and care.</p>
        </div>
      </section>

      {/* Contact */}
      <section className="py-5" style={{ backgroundColor: '#FCE6B4', color: '#000 ' }}>
        <div className="container ">
          <h2 className="fw-bold mb-3 text-black">Schedule a Free Estimate</h2>
          <p className="fs-5">Please call or email us to start your project discussion.</p>
          <p className="fs-5">
            <i className="fas fa-phone-alt me-2 fa-rotate-90"></i>
            <strong>+1 613 893 8931</strong>
          </p>
          <p className="fs-5">
      <i className="fas fa-map-marker-alt me-2"></i>
      <strong>373 Stoneway Dr, Nepean, Ontario, K2G6G8</strong>
    </p>
          <p className="fs-5">
            <i className="fas fa-envelope me-2"></i>
            <strong>detail@fineline-cf.com</strong>
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-3 text-center text-secondary fw-bold" style={{ backgroundColor: '#181818' }}>
        &copy; {new Date().getFullYear()} Fineline Carpentry & Flooring
      </footer>

      {/* Lightbox */}
      {selectedImage && (
        <div className="modal fade show d-block bg-black bg-opacity-75" onClick={() => setSelectedImage(null)}>
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content bg-transparent border-0">
              <img
                src={selectedImage}
                alt="Preview"
                className="img-fluid mx-auto d-block"
                style={{ maxHeight: '90vh', objectFit: 'contain' }}
              />
              <button
                className="btn position-absolute top-0 end-0 m-3"
                style={{ backgroundColor: '#FCE6B4' }}
                onClick={() => setSelectedImage(null)}
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
